import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { DashboardComponent } from './dashboard/dashboard.component';
import { UsersListComponent } from './users-list/users-list.component';
import { BlockUsersListComponent } from './block-users-list/block-user-list.component';

import { SurveyListComponent } from './survey-list/survey-list.component';
import { MapComponent } from './map/map.component';
import { NotificationsComponent } from './notifications/notifications.component';
import { ChangePasswordComponent } from './change-password/change-password.component';
import { ProfileComponent } from './profile/profile.component';
import { LanguageComponent } from './language/language.component';
import { CountryComponent } from './country/country.component';
import { SurveyScoreComponent } from './survey-score/survey-score.component';
import { UserSurveyComponent } from './user-survey/user-survey.component';
import { SocietyUserSurveyComponent } from './society-user-survey/society-user-survey/society-user-survey.component';
import { FormGroup, FormControl, ReactiveFormsModule, Validators } from '@angular/forms';
import { AuthGuard } from '../guard/auth.guard'
import { PagerService } from '../services/index';
import { CategoryComponent } from './category/category.component';
import { CategoryoptionComponent } from './category-option/category-option.component';

import { ViewSurveyComponent } from './view-survey/view-survey.component';
import { SurveyReportComponent } from './survey-report/survey-report.component';
import { WazQuestionComponent } from './waz-question/waz-question.component';
import { AnsweredSurveyReportComponent } from './answered-survey-report/answered-survey-report.component';
import { SurveyPricingComponent } from './survey-pricing/survey-pricing.component';
import { Component } from '@angular/core/src/metadata/directives';
import { TransactionReportComponent } from './transaction-report/transaction-report.component';
import { GroupSurveyListComponent } from './group-survey-list/group-survey-list.component';
import { GroupListComponent } from './group-list/group-list.component';
import { SocietyGroupListComponent } from './society-group-list/society-group-list.component';
import { RedeemListComponent } from './redeem-list/redeem-list.component';

import { SurveyCommentListComponent } from './survey-comment-list/survey-comment-list.component';
import { SurveyActivityReportListComponent } from './survey-activity-report-list/survey-activity-report-list.component';
import { ProfileVerificationReportListComponent } from "./profile-verification-report-list/profile-verification-report-list.component";
import { AdminLogReportListComponent } from "./admin-log-report-list/admin-log-report-list.component";
import { ReportedCommentListComponent } from "./reported-comment-list/reported-comment-list.component";
import { UserSurveyPostedQusestionComponent } from "./user-survey-posted-question/user-survey-posted-question.component";
import { ProfessionComponent } from './profession/profession.component';
import { ProfessionoptionComponent } from './profession-option/profession-option.component';

import { GroupUsersListComponent } from './group-users-list/group-users-list/group-users-list.component';
import { VideoReportComponent } from './video-report/video-report.component';
import { StateComponent } from './state/state.component';
import { CityComponent } from './city/city.component';
import { TimeComponent } from './time/time.component';
import { YearComponent } from './year/year.component';

import { UserCreditTransactionReportComponent } from './user-credit-transaction-report/user-credit-transaction-report.component';
import { AskWazzersVideoComponent } from './ask-wazzers-video/ask-wazzers-video.component';
import { StoryVideoComponent } from './story-video/story-video.component';

import { WAZaskComponent } from './waz-ask/waz-ask.component';
import { PointComponent } from './point/point.component';

import { VideosComponent } from './videos/videos.component';
import { AdminsListComponent } from './admin-list/admin-list.component';
import { WazVideosComponent } from './waz-videos/waz-videos.component';
import { LikeMySurveyListComponent } from './like-my-survey-list/like-my-survey-list.component';
import { TopTrendingSurveyComponent } from './top-trending-survey/top-trending-survey.component'
import { QueryComponent } from './query/query.component'
import { BusinessVideoComponent } from './business-video/business-video.component';
import { InfluenceComponent } from './influence/influence.component';


// import { FavouriteGroupSurveyComponent } from './favourite-group-survey/favourite-group-survey.component';
 import { LikeActivityReportComponent } from './like-activity-report/like-activity-report.component';
// import { FavoriteCountrySurveyComponent } from './favorite-country-survey/favorite-country-survey.component'
// import { FavoriteCitySurveyComponent } from './favorite-city-survey/favorite-city-survey.component'
// import { FavoriteWazzersComponent } from './favorite-wazzers/favorite-wazzers.component'
import { StoryComponent } from './story/story.component';

const routes: Routes = [
  {
    path: '',
    canActivate: [AuthGuard],
    component: DashboardComponent
  },
  {
    path: 'dashboard',
    canActivate: [AuthGuard],
    component: DashboardComponent
  },
  {
    path: 'user-list',
    canActivate: [AuthGuard],
    component: UsersListComponent
  },
  {
    path: 'admin-list',
    canActivate: [AuthGuard],
    component: AdminsListComponent
  },
  {
    path: 'block-user-list',
    canActivate: [AuthGuard],
    component: BlockUsersListComponent
  },
  {
    path: 'waz-ask',
    canActivate: [AuthGuard],
    component: WAZaskComponent
  },
  {
    path: 'point',
    canActivate: [AuthGuard],
    component: PointComponent
  },
  {
    path: 'video-waz',
    canActivate: [AuthGuard],
    component: WazVideosComponent
  },
  {
    path: 'user-list/:group_id/:prev_token',
    canActivate: [AuthGuard],
    component: UsersListComponent
  },
  {
    path: 'group-users-list',
    canActivate: [AuthGuard],
    component: UsersListComponent
  },

  {
    path: 'group-users-list/:group_id/:prev_token',
    canActivate: [AuthGuard],
    component: GroupUsersListComponent

  },
  {
    path: 'users',
    canActivate: [AuthGuard],
    component: UsersListComponent
  },
  {
    path: 'survey-list',
    canActivate: [AuthGuard],
    component: SurveyListComponent
  },
  {
    path: 'country-survey-list',
    canActivate: [AuthGuard],
    component: SurveyListComponent
  },

  {
    path: 'city-survey-list',
    canActivate: [AuthGuard],
    component: SurveyListComponent
  },
  {
    path: 'world-survey-list',
    canActivate: [AuthGuard],
    component: SurveyListComponent
  },
  {
    path: 'waz-view',
    canActivate: [AuthGuard],
    component: MapComponent
  },
  {
    path: 'notifications',
    canActivate: [AuthGuard],
    component: NotificationsComponent
  },
  {
    path: 'change-password',
    canActivate: [AuthGuard],
    component: ChangePasswordComponent
  },
  {
    path: 'manage-profile',
    canActivate: [AuthGuard],
    component: ProfileComponent
  },
  {
    path: 'language',
    canActivate: [AuthGuard],
    component: LanguageComponent
  },
  {
    path: 'country',
    canActivate: [AuthGuard],
    component: CountryComponent
  },
  {
    path: 'state',
    canActivate: [AuthGuard],
    component: StateComponent
  },
  {
    path: 'city',
    canActivate: [AuthGuard],
    component: CityComponent
  },
  { 
    path: 'time',
    canActivate: [AuthGuard],
    component: TimeComponent
  },
  { 
    path: 'year',
    canActivate: [AuthGuard],
    component: YearComponent
  },
  { 
    path: 'business-video',
    canActivate: [AuthGuard],
    component: BusinessVideoComponent
  },
  {
    path: 'influence',
    canActivate: [AuthGuard],
    component: InfluenceComponent
  },
  {
    path: 'setting',
    canActivate: [AuthGuard],
    component: SurveyScoreComponent
  },
  {
    path: 'user-profile/:user_id/:prev_token',
    canActivate: [AuthGuard],
    component: UserSurveyComponent
  },
  {
    path: 'user-profile1/:user_id/:prev_token',
    canActivate: [AuthGuard],
    component: SocietyUserSurveyComponent
  },
  {
    path: 'category',
    canActivate: [AuthGuard],
    component: CategoryComponent
  },
  {
    path: 'category-option',
    canActivate: [AuthGuard],
    component: CategoryoptionComponent
  },
  {
    path: 'category-option/:id',
    canActivate: [AuthGuard],
    component: CategoryoptionComponent
  },
  {
    path: 'survey/:survey_id/:prev_token',
    canActivate: [AuthGuard],
    component: ViewSurveyComponent
  },
  {
    path: 'survey/:survey_id/:group_id/:prev_token',
    canActivate: [AuthGuard],
    component: ViewSurveyComponent
  },
  {
    path: 'survey-report',
    canActivate: [AuthGuard],
    component: SurveyReportComponent
  },

  {
    path: 'waz-view-question',
    canActivate: [AuthGuard],
    component: WazQuestionComponent
  },
  {
    path: 'survey-answer-report',
    canActivate: [AuthGuard],
    component: AnsweredSurveyReportComponent
  },
  {
    path: 'pricing',
    canActivate: [AuthGuard],
    component: SurveyPricingComponent
  },
  {
    path: 'transaction-report',
    canActivate: [AuthGuard],
    component: TransactionReportComponent
  },
  {
    path: 'group-survey-list',
    canActivate: [AuthGuard],
    component: GroupSurveyListComponent
  },
  {
    path: 'redeem-list',
    canActivate: [AuthGuard],
    component: RedeemListComponent
  },
  {
    path: 'group-list',
    canActivate: [AuthGuard],
    component: GroupListComponent
  },

  {
    path: 'society-group-list',
    canActivate: [AuthGuard],
    component: SocietyGroupListComponent
  },


  //added on 5sep
  {
    path: 'survey-comment-list',
    canActivate: [AuthGuard],
    component: SurveyCommentListComponent
  },
  {
    path: 'country-survey-comment-list',
    canActivate: [AuthGuard],
    component: SurveyCommentListComponent
  },
  {
    path: 'world-survey-comment-list',
    canActivate: [AuthGuard],
    component: SurveyCommentListComponent
  },

  {
    path: 'survey-activity-report-list',
    canActivate: [AuthGuard],
    component: SurveyActivityReportListComponent
  },

  {
    path: 'profile-verification-report-list',
    canActivate: [AuthGuard],
    component: ProfileVerificationReportListComponent
  },
  {
    path: 'admin-log-report-list',
    canActivate: [AuthGuard],
    component: AdminLogReportListComponent
  },

  {
    path: 'reported-comment-list',
    canActivate: [AuthGuard],
    component: ReportedCommentListComponent
  },
  // {
  //   path: 'user-survey-posted-question',
  //   canActivate : [AuthGuard],
  //   component: UserSurveyPostedQusestionComponent
  // },
  {
    path: 'user-survey-posted-question/:user_id',
    canActivate: [AuthGuard],
    component: UserSurveyPostedQusestionComponent
  },
  {
    path: 'profession',
    canActivate: [AuthGuard],
    component: ProfessionComponent
  },
  {
    path: 'profession-option',
    canActivate: [AuthGuard],
    component: ProfessionoptionComponent
  },
  {
    path: 'profession-option/:id',
    canActivate: [AuthGuard],
    component: ProfessionoptionComponent
  },
  {
    path: 'video-report',
    canActivate: [AuthGuard],
    component: VideoReportComponent,
  },
  {
    path: 'videos',
    canActivate: [AuthGuard],
    component: VideosComponent,
  },
  {
    path: 'user-credit-transaction-report',
    canActivate: [AuthGuard],
    component: UserCreditTransactionReportComponent,
  },
  {
    path: 'user-credit-transaction-report/:prev_token',
    canActivate: [AuthGuard],
    component: UserCreditTransactionReportComponent,
  },
  {
    path: 'user-credit-report/:user_id/:user_name/:prev_token/:listType',
    canActivate: [AuthGuard],
    component: UserCreditTransactionReportComponent,
  },
  {
    path: 'ask-wazzers-video/:user_id/:question_id/:question',
    canActivate: [AuthGuard],
    component: AskWazzersVideoComponent
  },
  {
    path: 'story-video/:story_id/:question',
    canActivate: [AuthGuard],
    component: StoryVideoComponent
  },
  {
    path: 'like-activity-report',
    canActivate: [AuthGuard],
    component: LikeActivityReportComponent
  },
  // {
  //   path: 'favourite-group-survey',
  //   canActivate: [AuthGuard],
  //   component: FavouriteGroupSurveyComponent
  // },
  {
    path: 'top-trending-survey',
    canActivate: [AuthGuard],
    component: TopTrendingSurveyComponent
  },
  // {
  //   path: 'favorite-country-surveys',
  //   canActivate: [AuthGuard],
  //   component: FavoriteCountrySurveyComponent
  // },
  // {
  //   path: 'favorite-city-surveys',
  //   canActivate: [AuthGuard],
  //   component: FavoriteCitySurveyComponent
  // },
  // {
  //   path: 'favorite-wazzers',
  //   canActivate: [AuthGuard],
  //   component: FavoriteWazzersComponent
  // },
  {
    path: 'like-my-survey-list/:user_id',
    canActivate: [AuthGuard],
    component: LikeMySurveyListComponent
  },
  {
    path: 'story',
    canActivate: [AuthGuard],
    component: StoryComponent
  },
  {
    path: 'query/:query_id',
    canActivate: [AuthGuard],
    component: QueryComponent
  },

];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule, ReactiveFormsModule]
})
export class DashboardRoutingModule {

}



// WEBPACK FOOTER //
// /Users/vishitamandloi/Documents/vishitaProjects/waz/angular/adminportal/waz-admin-panel/src/app/dashboard/dashboard-routing.module.ts